import { gql } from '@apollo/client';
import { Button } from 'components/buttons/button';
import { useGetAllBooksellersQuery } from 'lib/graphql-generated';
import { useState } from 'react';
import { BooksellerCard } from './bookseller-card';
import { NewBookseller } from './new-bookseller';

const GET_ALL_BOOKSELLERS = gql`
  query GetAllBooksellers {
    booksellers(order_by: { id: asc }) {
      id
      name
      avatar
      video_url
    }
  }
`;

export const BookSellerBlock = () => {
  const { data, error, loading, refetch } = useGetAllBooksellersQuery({
    fetchPolicy: 'cache-and-network',
  });
  const [showAddNew, setShowAddNew] = useState<boolean>(false);

  return (
    <article className='flex flex-col pt-8 space-y-8'>
      <Button
        onClick={() => setShowAddNew(!showAddNew)}
        buttonType='secondary'
        buttonSize='lg'
        className='mr-auto ml-auto xl:ml-auto xl:mr-0'>
        {showAddNew ? 'Cancel' : 'Add Bookseller'}
      </Button>
      {showAddNew && (
        <NewBookseller
          handleClose={() => {
            setShowAddNew(false);
            refetch();
          }}
        />
      )}
      {data?.booksellers.length > 0 ? (
        <ul className='grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
          {data.booksellers.map((bookseller) => (
            <BooksellerCard bookseller={bookseller} key={bookseller.id} />
          ))}
        </ul>
      ) : (
        <p className='self-center pt-20'>Could not find booksellers</p>
      )}
    </article>
  );
};
